import BaseService from './base.service';

export default class TemplateService extends BaseService {
  getTemplates(payload) {
    const query = this.getQueryString(payload);
    return this.get(`/templates${query}`);
  }

  createTemplate(payload) {
    return this.post('/templates', payload);
  }

  updateTemplate(id, payload) {
    return this.put(`/templates/${id}`, payload);
  }

  deleteTemplate(id) {
    return this.delete(`/templates/${id}`);
  }

  getTemplateById(id) {
    return this.get(`/templates/${id}`);
  }
}
